import dayjs from 'dayjs'
import {Timestamp} from 'firebase/firestore'
import {JsonProperty} from 'json-object-mapper'

export class Todo {
  @JsonProperty()
  public id: string
  @JsonProperty()
  public name: string
  @JsonProperty()
  public dueDate: Timestamp
  @JsonProperty()
  public additionalInfo?: string
  @JsonProperty()
  public notes?: string
  @JsonProperty()
  public read: boolean = false
  @JsonProperty()
  public displayable: boolean = false
  @JsonProperty()
  public done: boolean = false

  isPast() {
    return dayjs(this.dueDate.toDate()).isBefore(dayjs())
  }

  status() {
    if (this.done) {
      return 'OK'
    }
    const time = dayjs(this.dueDate.toDate())
    if (this.isPast()) {
      return 'Risk'
    } else {
      if (time.isAfter(dayjs().add(1, 'month'))) {
        return 'Upcoming'
      } else {
        return 'Pending'
      }
    }
  }

  statusColor() {
    switch (this.status()) {
      case 'OK':
      case 'Upcoming':
        return 'green'
      case 'Pending':
        return 'orange'
      case 'Risk':
        return 'red'
    }
  }
}
